/* eslint-disable */
import React, { FC, useEffect, useRef, useState } from 'react'
import { RouteComponentProps, useHistory, withRouter } from 'react-router-dom'
import { toast, ToastOptions } from 'react-toastify'

import {
  ResumoDeDocumentosDeSaidaMapper,
  ResumoDeDocumentosAnalisados,
  UploadDeDocumentos,
  UploadDocumentos,
  useRelacaoDeDocumentos,
  selecaoDeDocumentosParaEnvio
} from 'src/compartilhados'
import {
  Breadcrumb,
  Carregando,
  ErroContainerLayout,
  ErroLayoutContainer,
  IconeBack,
  Link,
  Modal,
  ModalRef
} from 'src/componentes'
import { Botao } from 'src/componentes/botao'
import { Api } from 'src/servicos'
import { getApiError } from 'src/servicos/instancias-api'
import {
  SituacaoUpload,
  TipoDocumentoCursoCertificacao,
  ResumoDocumentosCursoCertificacao,
  UsuarioPerfil
} from 'src/tipos'
import { CursoCertificacaoPayload } from 'src/dto'

import {
  ModalMotivoRejeicao,
  ModalVisualizacaoDocumento,
  ModalVisualizacaoDocumentoRef
} from '../../ipgs/alunos/documentos/componentes'
import { ModalMotivoRejeicaoDados } from '../../ipgs/alunos/documentos/componentes/modal-motivo-rejeicao/modal-motivo-rejeicao.component'
import {
  BotaoDeSalvar,
  ContainerBreadcrumbs,
  ContainerDaPagina,
  ContainerDosBotoes,
  ContainerLink,
  DescricaoContainer,
  Dicas,
  TituloComplementar
} from '../../ipgs/alunos/documentos/style'
import { RejeicaoDocumento } from '../../ipgs/alunos/documentos/tipos'
import { MapearDocumentosCursoCertificacao } from './mappers'
import {
  DICA_CONSULTA_DOCUMENTOS_FILA,
  useSomenteConsultaDocumentosFilaTrabalho
} from './somente-consulta-fila-trabalho'

const tituloDaPagina = 'Documentação PPC'
const erroAoCarregarDados = 'Ops! Houve algum problema no carregamento dos dados.'
const erroAoBaixarDocumentos = 'Erro ao baixar documentos.'
const erroAoObterDocumentos = 'Não foi possível obter os documentos do PPC.'
const erroAoAtualizarDocumentos = 'Erro ao atualizar documentos.'
const erroAoEnviarDocumentos = 'Erro ao enviar documentos.'
const erroAoProcessarDocumentos = 'Erro ao processar documentos.'
const ErroAoEnviarAnalises = 'Erro ao enviar análise de aprovação de documentos.'
const toastOptions = { type: 'error' } as ToastOptions

export type DocumentosPPCCertificacaoProps = RouteComponentProps<{
  id: string
}>

const DocumentosPPCCertificacao: FC<DocumentosPPCCertificacaoProps> = ({
  match
}) => {
  const history = useHistory()
  const somenteConsulta = useSomenteConsultaDocumentosFilaTrabalho()
  const { documentos, atualizar, reiniciar } = useRelacaoDeDocumentos()
  const [pronto, definirPronto] = useState<boolean>()
  const [carregando, definirCarregando] = useState<boolean>()
  const [dadosDoCurso, definirDadosDoCurso] = useState<CursoCertificacaoPayload>()
  const [dadosDoUsuario, definirDadosDoUsuario] = useState<UsuarioPerfil>()
  const [rejeicaoDeDocumento, definirRejeicaoDeDocumento] = useState<RejeicaoDocumento>()

  const modalDeCancelamentoRef = useRef<ModalRef>(null)
  const modalMotivoRejeicaoRef = useRef<ModalRef>(null)
  const modalVisualizacaoRef = useRef<ModalVisualizacaoDocumentoRef>(null)

  const { limparErro, definirErro, erro } = ErroLayoutContainer.useContainer()

  const montarUrlDeVisualizacao = (base64: string, contentType: string): string => {
    const base64Normalizado = base64?.trim()

    if (!base64Normalizado) return null
    if (base64Normalizado.startsWith('data:')) return base64Normalizado

    const tipoDoConteudo = contentType || 'application/pdf'
    return `data:${tipoDoConteudo};base64,${base64Normalizado}`
  }

  const obterCursoPorId = async (id: string): Promise<CursoCertificacaoPayload> => {
    try {
      const curso = await Api.RequisitarCursoCertificacao(id)
      return curso
    } catch (error) {
      definirErro({ mensagens: erroAoCarregarDados })
      return null
    }
  }

  const obterUsuarioPorId = async (usuarioId: string): Promise<any> => {
    try {
      const usuario = await Api.RequisitarUsuarioPorEmail(usuarioId)
      return usuario
    } catch (error) {
      definirErro({ mensagens: erroAoCarregarDados })
      return null
    }
  }

  const obterResumoDeDocumentos = async (cursoId: string): Promise<void> => {
    try {
      const resumoDocumentos = await Api.ObterResumoDeDocumentosCursoCertificacao(cursoId)

      if (resumoDocumentos?.length > 0) {
        const docs = MapearDocumentosCursoCertificacao(resumoDocumentos)
        reiniciar(docs)
      }
    } catch (error) {
      definirErro({ mensagens: erroAoCarregarDados })
    }
  }

  const uploadDeAnalises = async (analises: UploadDocumentos[]): Promise<void> => {
    const resultado = ResumoDeDocumentosAnalisados(analises)

    if (!resultado?.documentos?.length) {
      toast('Nenhum documento foi analisado', { type: 'warning' })
      return
    }

    const resposta = await Api.ValidarDocumentosCurso(resultado)

    if (resposta) {
      toast('Documentos validados com sucesso!', { type: 'success' })
      history.goBack()
    } else {
      toast(ErroAoEnviarAnalises, toastOptions)
    }
  }

  const eventoDeUpload = async (): Promise<void> => {
    if (somenteConsulta) return

    const { analises } = selecaoDeDocumentosParaEnvio(documentos)

    if (!analises?.length) {
      toast('Nenhum documento foi analisado', { type: 'warning' })
      return
    }

    try {
      await uploadDeAnalises(analises)
    } catch (erro) {
      if ((erro as any)?.isAxiosError) {
        return
      }

      const mensagens = await getApiError(erro as Error)
      toast(mensagens[0] || ErroAoEnviarAnalises, toastOptions)
    }
  }

  const obterDownloadDeDocumentos = async (documentoId: string): Promise<void> => {
    try {
      await Api.DownloadDocumentosCursoCertificacao(dadosDoCurso.id, documentoId)
    } catch (erro) {
      toast(erroAoBaixarDocumentos, toastOptions)
    }
  }

  const visualizarDocumento = async (documentoId: string) => {
    try {
      const documento = await Api.RequisitarDocumentoCursoCertificacao(
        dadosDoCurso.id,
        documentoId
      )

      if (documento) {
        const urlDoDocumento = montarUrlDeVisualizacao(
          documento.base64,
          documento.contentType
        )

        if (!urlDoDocumento) {
          toast(erroAoObterDocumentos, toastOptions)
          return
        }

        modalVisualizacaoRef?.current?.abrir(urlDoDocumento)
      }
    } catch (error) {
      toast(erroAoObterDocumentos, toastOptions)
    }
  }

  const obterDocumentacao = async (): Promise<void> => {
    try {
      definirPronto(false)
      limparErro()
      const curso = await obterCursoPorId(match.params.id)

      if (curso) {
        definirDadosDoCurso(curso)
        await obterResumoDeDocumentos(curso.id)

        // Buscar dados do usuário (parceiro) que criou o curso
        if (curso.usuarioPerfilId) {
          const usuario = await obterUsuarioPorId(curso.usuarioPerfilId)
          definirDadosDoUsuario(usuario)
        }
      }

      definirPronto(true)
    } catch (error) {
      definirErro({ mensagens: erroAoCarregarDados })
    }
  }

  const aprovacao = (id: string): void => {
    const index = documentos.findIndex(x => x.id === id)

    if (index >= 0) {
      const documentoAtualizado = { ...documentos[index] }
      documentoAtualizado.analisado = true
      documentoAtualizado.status = SituacaoUpload.Aprovado
      atualizar(documentoAtualizado)
    }
  }

  const rejeicao = (id: string): void => {
    definirRejeicaoDeDocumento({ id: id })
    modalMotivoRejeicaoRef?.current?.abrir()
  }

  const obterMotivoDaRejeicao = (dados: ModalMotivoRejeicaoDados) => {
    const index = documentos.findIndex(
      x => x.id === rejeicaoDeDocumento.id
    )

    if (index >= 0) {
      const documentoAtualizado = { ...documentos[index] }
      documentoAtualizado.analisado = true
      documentoAtualizado.status = SituacaoUpload.Recusado
      documentoAtualizado.motivoDaRejeicao = dados.motivoDaRejeicao
      atualizar(documentoAtualizado)
    }

    modalMotivoRejeicaoRef?.current?.fechar()
    definirRejeicaoDeDocumento(null)
  }

  const fecharModalDeCancelamento = () => {
    modalDeCancelamentoRef?.current?.fechar()
  }

  const abrirModalDeCancelamento = () => {
    modalDeCancelamentoRef?.current?.abrir()
  }

  useEffect(() => {
    obterDocumentacao()
  }, [match.params.id])

  const documentosOrdenados = documentos.sort((a, b) => a.ordemExibicao - b.ordemExibicao)

  const TipoDocumentoUpload = {
    [TipoDocumentoCursoCertificacao.PPC]: 'Projeto Pedagógico do Curso (PPC)'
  }

  if (erro) return <ErroContainerLayout />
  if (!pronto) return <Carregando />

  return (
    <ContainerDaPagina>
      {carregando && <Carregando />}

      <ContainerBreadcrumbs>
        <ContainerLink>
          <Link href="#" texto="Voltar" acaoVoltar={() => history.goBack()} />
        </ContainerLink>

        <Breadcrumb atalhos={[]} titulo={tituloDaPagina} />
      </ContainerBreadcrumbs>

      <TituloComplementar>{tituloDaPagina}</TituloComplementar>

      <DescricaoContainer>
        <p>Nome usuário: {(dadosDoUsuario as any)?.nomeApresentacao || (dadosDoUsuario as any)?.email}</p>
        <p>E-mail usuário: {(dadosDoUsuario as any)?.email}</p>
        <p>Nome da turma: {dadosDoCurso?.nome}</p>
      </DescricaoContainer>

      <Dicas>
        {somenteConsulta
          ? DICA_CONSULTA_DOCUMENTOS_FILA
          : 'O envio do PPC é obrigatório para aprovação do curso. Analise o documento e aprove ou recuse conforme a conformidade.'}
      </Dicas>

      {documentosOrdenados.map((documento) => (
        <UploadDeDocumentos
          key={documento.id}
          documento={documento}
          eventoDeVisualizacao={visualizarDocumento}
          eventoDeDownload={obterDownloadDeDocumentos}
          eventoDeMudanca={atualizar}
          controleDeAprovacao={{
            ativo: !somenteConsulta,
            eventoDeAprovacao: aprovacao,
            eventoDeRejeicao: rejeicao
          }}
          modoVisualizacao={true}
          somenteConsulta={somenteConsulta}
        />
      ))}

      <ContainerDosBotoes>
        <Botao
          texto={somenteConsulta ? 'Voltar' : 'Cancelar'}
          onClick={somenteConsulta ? () => history.goBack() : abrirModalDeCancelamento}
        />
        {!somenteConsulta && (
          <BotaoDeSalvar texto="Salvar" onClick={eventoDeUpload} />
        )}
      </ContainerDosBotoes>

      <Modal
        ref={modalDeCancelamentoRef}
        titulo="Deseja cancelar?"
        acaoPrimaria={{
          titulo: 'Sim',
          acao: () => history.goBack()
        }}
        acaoSecundario={{
          titulo: 'Não',
          acao: fecharModalDeCancelamento
        }}
      >
        Tem certeza que deseja sair sem salvar as alterações?
      </Modal>

      <ModalMotivoRejeicao
        ref={modalMotivoRejeicaoRef}
        acaoPrimaria={obterMotivoDaRejeicao}
      />

      <ModalVisualizacaoDocumento
        ref={modalVisualizacaoRef}
        id="modal-visualizacao-documento-ppc-certificacao"
      />
    </ContainerDaPagina>
  )
}

const Container: FC<DocumentosPPCCertificacaoProps> = (
  props: DocumentosPPCCertificacaoProps
) => (
  <ErroLayoutContainer.Provider>
    <DocumentosPPCCertificacao {...props} />
  </ErroLayoutContainer.Provider>
)

export default withRouter(Container)
